import * as React from 'react';
import { FileDto } from '../../Api/ApiServer';

export interface IImageViewerProps {
    fileDownloadUri: string;
    alt: string;
    // selectedFile: FileDto;
}

export default function ImageViewer(props: IImageViewerProps) {
    const { fileDownloadUri, alt } = props;
    return (
        <div style={{ width: "45vw", height: "calc(100vh - 350px)", overflow: 'auto' }}>
            <img
                src={fileDownloadUri}
                alt={alt}
                style={{ maxWidth: '100%', height: 'auto' }}
            />
        </div>
    );
}
